exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Builder-Signal-___suggestions__tag___hSoZv{margin:0 3px 2px 0;border:none;background-color:#0693d4;color:#fff;white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"tag": "src-components-Builder-Signal-___suggestions__tag___hSoZv"
};